import { useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const useRealtime = (tableName, callback) => {
    useEffect(() => {
        const channel = supabase
            .channel(`public-${tableName}`)
            .on(
                'postgres_changes',
                { event: '*', schema: 'public', table: tableName },
                (payload) => {
                    // Enviamos el evento completo (INSERT, DELETE, UPDATE) al componente
                    callback(payload);
                }
            )
            .subscribe();

        return () => {
            supabase.removeChannel(channel);
        };
    }, [tableName, callback]);
};